













import { Vue, Component, Prop } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { Tab, Tabs, List, Swipe, SwipeItem } from 'vant';
import BottomBar from './components/BottomBar.vue';
import DetailText from './components/DetailText.vue';
import { getVideoDetail } from './api/index';
import SyPlayer from '@/components/SyPlayer.vue';
import ReturnTag from './components/ReturnTag.vue';
import { getLiveTime } from './ts/common';
Vue.use(Tab)
  .use(Tabs)
  .use(List)
  .use(Swipe)
  .use(SwipeItem);
import * as config from './config';
@Component({
  name: 'SSHDVideoPage',
  components: {
    DetailText,
    BottomBar,
    SyPlayer,
    ReturnTag,
  },
})
export default class VideoPage extends Vue {
  public videoDetail = {};
  public createDate = '';
  created() {
    getVideoDetail(this.$route.query.id).then(
      (res) => (
        (this.videoDetail = res.data),
        (this.createDate = getLiveTime(res.data.createtime).a)
      ),
    );
  }
  backPath(e: any) {
    this.$router.push({
      path: '/20200710SSHD/ListPage',
      query: { type: e },
    });
  }
}
